import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './Admin.css';

const AdminLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const toggleMobileSidebar = () => {
    setShowMobileSidebar(!showMobileSidebar);
  };

  const closeMobileSidebar = () => {
    setShowMobileSidebar(false);
  };

  const menuItems = [
    {
      path: '/admin/dashboard',
      icon: 'fas fa-tachometer-alt',
      label: 'Dashboard',
    },
    {
      path: '/admin/registrations',
      icon: 'fas fa-list-alt',
      label: 'Đăng ký',
    },
  ];

  return (
    <div className={`admin-layout ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      {/* Mobile Overlay */}
      {showMobileSidebar && (
        <div className="sidebar-overlay" onClick={closeMobileSidebar}></div>
      )}

      {/* Sidebar */}
      <aside className={`admin-sidebar ${showMobileSidebar ? 'show' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <i className="fas fa-solar-panel"></i>
            {!sidebarCollapsed && <span>G9 Admin</span>}
          </div>
          <button 
            className="sidebar-toggle d-none d-lg-block"
            onClick={toggleSidebar}
            title={sidebarCollapsed ? 'Mở rộng' : 'Thu gọn'}
          >
            <i className={`fas fa-chevron-${sidebarCollapsed ? 'right' : 'left'}`}></i>
          </button>
          <button 
            className="sidebar-close d-lg-none"
            onClick={closeMobileSidebar}
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        <nav className="sidebar-nav">
          <ul className="nav-menu">
            {menuItems.map((item) => (
              <li key={item.path} className="nav-item">
                <NavLink 
                  to={item.path} 
                  className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                  onClick={closeMobileSidebar}
                >
                  <i className={item.icon}></i>
                  {!sidebarCollapsed && <span>{item.label}</span>}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">
              <i className="fas fa-user-circle"></i>
            </div>
            {!sidebarCollapsed && (
              <div className="user-details">
                <span className="user-name">{user?.username || 'Admin'}</span>
                <span className="user-role">Administrator</span>
              </div>
            )}
          </div>
          <button 
            className="btn-logout"
            onClick={handleLogout}
            title="Đăng xuất"
          >
            <i className="fas fa-sign-out-alt"></i>
            {!sidebarCollapsed && <span>Đăng xuất</span>}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="admin-main">
        {/* Top Header */}
        <header className="admin-header">
          <div className="header-left">
            <button 
              className="btn-mobile-menu d-lg-none"
              onClick={toggleMobileSidebar}
            >
              <i className="fas fa-bars"></i>
            </button>
            <h1 className="header-title">G9 Energy Admin</h1>
          </div>
          <div className="header-right">
            <a 
              href="/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-outline-primary btn-sm"
            >
              <i className="fas fa-external-link-alt me-2"></i>
              Xem Website
            </a>
            <div className="dropdown">
              <button 
                className="btn btn-link dropdown-toggle user-dropdown"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-user-circle me-2"></i>
                {user?.username || 'Admin'}
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <span className="dropdown-item-text">
                    <small className="text-muted">Đăng nhập với</small>
                    <br />
                    <strong>{user?.username}</strong>
                  </span>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <button className="dropdown-item text-danger" onClick={handleLogout}>
                    <i className="fas fa-sign-out-alt me-2"></i>
                    Đăng xuất
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </header>

        {/* Content Area */}
        <main className="admin-content">
          <Outlet />
        </main>

        {/* Footer */}
        <footer className="admin-footer">
          <p>&copy; 2024 G9 Energy. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default AdminLayout;